import React, { useState } from 'react'
import {
  Button,
  Grid,
  IconButton,
  MenuItem,
  TextField,
} from '@material-ui/core'
import { Link } from 'react-router-dom/cjs/react-router-dom'
import Icon from '@mdi/react'
import { mdiFilterMultiple, mdiNoteEditOutline } from '@mdi/js'

import filterStylesComponents from '../../../assets/filterComponentsStyles'
import BaseFilter from '../../../components/hooks/BaseFilter'
import colors from '../../../assets/colors'

const Filter = ({ form, setForm }) => {
  const styles = filterStylesComponents()

  const [currentFilters, setCurrentFilters] = useState({
    title: form.title,
    dispatched: form.dispatched,
  })

  const handleChange = e => {
    const { name, value } = e.target

    setCurrentFilters({
      ...currentFilters,
      [name]: value,
    })
  }

  const handleSubmit = e => {
    e.preventDefault()

    setForm({
      ...form,
      ...currentFilters,
      page: 1,
    })
  }

  return (
    <BaseFilter>
      <form onSubmit={handleSubmit} style={{ width: '100%' }}>
        <Grid container spacing={3}>
          <Grid item xs={9}>
            <Grid container spacing={2}>
              <Grid item sm={4} md={3}>
                <TextField
                  type="text"
                  name="title"
                  variant="standard"
                  fullWidth
                  onChange={handleChange}
                  value={currentFilters.title}
                  label="Filtre por título"
                />
              </Grid>
              <Grid item sm={4} md={2}>
                <TextField
                  select
                  name="dispatched"
                  onChange={handleChange}
                  variant="standard"
                  fullWidth
                  label="Situação"
                  value={currentFilters.dispatched}
                >
                  <MenuItem value="">Todos</MenuItem>
                  <MenuItem value="1">Disparados</MenuItem>
                  <MenuItem value="0">Não disparados</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs container alignItems="flex-end">
                <Button type="submit" className={styles.btnMoreFilters}>
                  <Icon
                    path={mdiFilterMultiple}
                    size={1}
                    color={colors.secondary}
                  />
                  {` Filtrar`}
                </Button>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs className={styles.areaButtons}>
            <IconButton
              color="primary"
              variant="contained"
              component={Link}
              to="/alerts/create-edit/new"
              className={styles.btnAdd}
            >
              <Icon path={mdiNoteEditOutline} size={1} />
              Cadastrar
            </IconButton>
          </Grid>
        </Grid>
      </form>
    </BaseFilter>
  )
}

export default Filter
